import _slicedToArray from "/Users/jamieschaedel/Sites/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
import { appendClassName } from "./view-helpers";

function getRaw(result, value) {
  if (!result[value] || !result[value].raw) return;
  return result[value].raw;
}

function getSnippet(result, value) {
  if (!result[value] || !result[value].snippet) return;
  return result[value].snippet;
}

function getSuggestionTitle(suggestionType, autocompleteSuggestions) {
  if (autocompleteSuggestions.sectionTitle) {
    return autocompleteSuggestions.sectionTitle;
  }

  if (autocompleteSuggestions[suggestionType] && autocompleteSuggestions[suggestionType].sectionTitle) {
    return autocompleteSuggestions[suggestionType].sectionTitle;
  }
}

function getSuggestionDisplayField(suggestionType, autocompleteSuggestions) {
  if (autocompleteSuggestions.queryType === "results") {
    return autocompleteSuggestions.displayField;
  }

  if (autocompleteSuggestions[suggestionType] && autocompleteSuggestions[suggestionType].queryType === "results") {
    return autocompleteSuggestions[suggestionType].displayField;
  }
}

function Autocomplete(_ref) {
  var autocompleteResults = _ref.autocompleteResults,
      autocompletedResults = _ref.autocompletedResults,
      autocompleteSuggestions = _ref.autocompleteSuggestions,
      autocompletedSuggestions = _ref.autocompletedSuggestions,
      className = _ref.className,
      getItemProps = _ref.getItemProps,
      getMenuProps = _ref.getMenuProps;
  var index = 0;
  return React.createElement("div", Object.assign({}, getMenuProps({
    className: appendClassName("sui-search-box__autocomplete-container", className)
  })), React.createElement("div", null, !!autocompleteSuggestions && Object.entries(autocompletedSuggestions).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        suggestionType = _ref3[0],
        suggestions = _ref3[1];

    return React.createElement(React.Fragment, {
      key: suggestionType
    }, getSuggestionTitle(suggestionType, autocompleteSuggestions) && suggestions.length > 0 && React.createElement("div", {
      className: "sui-search-box__section-title"
    }, getSuggestionTitle(suggestionType, autocompleteSuggestions)), suggestions.length > 0 && React.createElement("ul", {
      className: "sui-search-box__suggestion-list"
    }, suggestions.map(function (suggestion) {
      var _a;

      index++;

      if (suggestion.queryType === "results") {
        var displayField = null;

        if (autocompleteSuggestions === true) {
          displayField = Object.keys(suggestion.result)[0];
        } else {
          displayField = getSuggestionDisplayField(suggestionType, autocompleteSuggestions);
        }

        var suggestionValue = (_a = suggestion.result[displayField]) === null || _a === void 0 ? void 0 : _a.raw;
        return React.createElement("li", Object.assign({}, getItemProps({
          key: suggestionValue,
          index: index - 1,
          item: {
            suggestion: suggestionValue
          }
        }), {
          "data-transaction-name": "query suggestion"
        }), React.createElement("span", null, suggestionValue));
      }

      return React.createElement("li", Object.assign({}, getItemProps({
        key: suggestion.suggestion || suggestion.highlight,
        index: index - 1,
        item: suggestion
      }), {
        "data-transaction-name": "query suggestion"
      }), suggestion.highlight ? React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: suggestion.highlight
        }
      }) : React.createElement("span", null, suggestion.suggestion));
    })));
  }), !!autocompleteResults && !!autocompletedResults && typeof autocompleteResults !== "boolean" && autocompletedResults.length > 0 && autocompleteResults.sectionTitle && React.createElement("div", {
    className: "sui-search-box__section-title"
  }, autocompleteResults.sectionTitle), !!autocompleteResults && !!autocompletedResults && autocompletedResults.length > 0 && React.createElement("ul", {
    className: "sui-search-box__results-list"
  }, autocompletedResults.map(function (result) {
    index++;
    var titleField = typeof autocompleteResults === "boolean" ? null : autocompleteResults.titleField;
    var titleSnippet = getSnippet(result, titleField);
    var titleRaw = getRaw(result, titleField);
    return React.createElement("li", Object.assign({}, getItemProps({
      key: result.id.raw,
      index: index - 1,
      item: result
    })), titleSnippet ? React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: titleSnippet
      }
    }) : React.createElement("span", null, titleRaw));
  }))));
}

export default Autocomplete;